// filtering with jquery plugin

require('waypoints/lib/jquery.waypoints.min.js');
require('imagesloaded/imagesloaded.pkgd.min');
var mixitup = require('mixitup');

 contentItemsFilter = {

	$instances: null,

	init: function(viaWaypoints) {
		var _this = this;
		_this.$instances = $('.js-content-items-filter');

		if (!_this.$instances.length) {
			return false;
		}

		// check/cleanup
		_this.$instances.each(function(i, el) {
			if (!$(el).data('target')) {
				// console.log('Missing data-target for content-items-filter!');
				_this.$instances.splice(i, 1);
			}
		});

		_this.initFilteringControls(viaWaypoints);
		_this.setFilteringControlsEventHandlers();
	},

	initFilteringControls: function(viaWaypoints) {
		var _this = this;


        _this.$instances.each(function(i, el) {
			var $target = $($(el).data('target'));
            var mixer = mixitup($target);


            if (!Modernizr.mq('(min-width: 768px)')) {
				if (mixer) {
					// no need to destroy, it seems to work fine now
					 $target.mixitup('destroy');
				}
				// return true;
			}

			// when user scrolls in the view, let's init
			if (viaWaypoints) {
				$(el).parents('.stripe').waypoint({
					offset: '150%',
					handler: function(direction) {
						$target.imagesLoaded(function() {
                            mixitup($target, {
                                selectors: {
                                    filter: '.js-mixitup-filter',
                                    target: '.mix'
                                }
                            });
						});
					}
				});
			}
			else {
				$target.imagesLoaded(function() {
                    mixitup($target, {
                        selectors: {
                            filter: '.js-mixitup-filter',
                            target: '.mix'
                        }
                    });
				});
			}
		});
	},

	setFilteringControlsEventHandlers: function($links) {
		var _this = this;

		_this.$instances.each(function(i, el) {
			var $links = $(el).find('a');

			$links.on('click', function(e) {
				e.preventDefault();

				$links.parent().removeClass('content-items-filter__item--active');
				$(this).parent().addClass('content-items-filter__item--active');
			});
		});
	},

	resetMenu: function() {
		var $links = this.$instances.find('a');

		$links.parent().removeClass('content-items-filter__item--active');
		$links.eq(0).parent().addClass('content-items-filter__item--active');
	}
};

contentItemsFilter.init();
